export enum FollowTargetTypeEnum {
  DANCE_CLASS = "DANCE_CLASS",
  DANCE_EVENT = "DANCE_EVENT",
  DANCE_SCHOOL = "DANCE_SCHOOL",
  ROOM_RENTAL = "ROOM_RENTAL",
  LOCATION = "LOCATION",
  USER = "USER"
}
